export default class PriceUtil {

   /**
    * Formats the given input number as Euro in German style with empty fractions removed.
    * @param input The number to format.
    */
   public static formatGermanWithFractionsOptional(input: number): string {
      let price = input.toLocaleString('de', {style: 'currency', currency: 'EUR'});
      if (price.endsWith(',00 €')) {
         price = price.replace(',00', '');
      }
      return price;
   }
}
